import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17.7778",
  height: "16",
  viewBox: "0 0 17.7778 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M13.3333 3.55556L12.08 4.80889L14.3733 7.11111H5.33333V8.88889H14.3733L12.08 11.1822L13.3333 12.4444L17.7778 8L13.3333 3.55556ZM1.77778 1.77778H8.88889V0H1.77778C0.8 0 0 0.8 0 1.77778V14.2222C0 15.2 0.8 16 1.77778 16H8.88889V14.2222H1.77778V1.77778Z",
        fill: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }